export default {"src":"/_next/static/media/icon_field-search.ca978a23.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};